export { DifficultyIcon, default } from './DifficultyIcon';
